import { HDSButton } from '@here/hds-react-components'
import { i18n } from 'lib/i18n'
import React from 'react'

interface SearchInAreaButtonProps {
  clickHandler: () => void
}

export function SearchInAreaButton({ clickHandler }: SearchInAreaButtonProps): JSX.Element {
  const searchInAreaButtonLabel = i18n('search-in-this-area-label')
  return (
    <div>
      <HDSButton
        icon="search"
        onClick={clickHandler}
        size="medium"
        type="button"
        variant="floating"
        width="16rem"
      >
        {searchInAreaButtonLabel}
      </HDSButton>
    </div>
  )
}
